import { forwardRef } from 'react';

// `label` è obbligatoria: nessun pulsante con sola icona resta muto per lo screen reader.
const IconButton = forwardRef(function IconButton(
  { icon: Icon, label, size = 20, tone = 'default', className = '', ...resto }, ref) {
  const toni = {
    default: 'text-muted hover:text-ink hover:bg-surface-2',
    danger: 'text-danger hover:bg-danger-bg',
    brand: 'text-brand-700 hover:bg-brand-50',
  };
  return (
    <button
      ref={ref}
      type="button"
      aria-label={label}
      title={label}
      className={`inline-flex h-11 w-11 items-center justify-center rounded-full transition-colors
        disabled:opacity-50 ${toni[tone]} ${className}`}
      {...resto}
    >
      <Icon size={size} aria-hidden />
    </button>
  );
});

export default IconButton;
